<template>
  <div>
    <div class="page_title flex between">
      商城设置
      <span>
        <el-button
          type="primary"
          style="width:100px"
          @click="submit"
          :disabled="module_id_array[0]?!module_id_array.includes('363'):false"
        >保存</el-button>
        <el-button plain style="width:100px" @click="getInfo">取消</el-button>
      </span>
    </div>
    <div style="padding:20px;">
      <div class="container">
        <div class="title">会员设置</div>
        <el-form :model="info" :rules="rules" ref="ruleForm" label-width="200px">
          <el-form-item label="兑换额度发放" prop="exchange_limit">
            <span style="margin-right:5px">每月</span>
            <el-input-number
              v-model="info.exchange_limit"
              step-strictly
              :step="1"
              :min="0"
              :max="9999999999"
              :controls="false"
              placeholder="请输入数字"
              style="width:146px"
            ></el-input-number>
          </el-form-item>
          <el-form-item label="兑换额度累积">
            <el-radio v-model="info.exchange_type" :label="1">可累积</el-radio>
            <el-radio v-model="info.exchange_type" :label="0">不可累积</el-radio>
          </el-form-item>
          <el-form-item label="季卡价格" prop="quarter_money">
            <el-input-number
              v-model="info.quarter_money"
              :min="0"
              :max="999999.99"
              :controls="false"
              placeholder="请输入数字"
            ></el-input-number>
            <span style="margin-left:5px">元</span>
          </el-form-item>
          <el-form-item label="年卡价格" prop="year_money">
            <el-input-number
              v-model="info.year_money"
              :min="0"
              :max="999999.99"
              :controls="false"
              placeholder="请输入数字"
            ></el-input-number>
            <span style="margin-left:5px">元</span>
          </el-form-item>
          <el-form-item label="季卡续费价格" prop="quarter_renew_money">
            <el-input-number
              v-model="info.quarter_renew_money"
              :min="0"
              :max="999999.99"
              :controls="false"
              placeholder="请输入数字"
            ></el-input-number>
            <span style="margin-left:5px">元</span>
          </el-form-item>
          <el-form-item label="年卡续费价格" prop="year_renew_money">
            <el-input-number
              v-model="info.year_renew_money"
              :min="0"
              :max="999999.99"
              :controls="false"
              placeholder="请输入数字"
            ></el-input-number>
            <span style="margin-left:5px">元</span>
          </el-form-item>
          <div class="flex">
            <el-form-item label="季卡会员购药立减" prop="quarter_month_times">
              <span>每月</span>
              <el-input-number
                v-model="info.quarter_month_times"
                :min="0"
                :max="99"
                :precision="0"
                :controls="false"
                placeholder="请输入数字"
                style="margin:0 5px;width:146px"
              ></el-input-number>
              <span>次</span>
            </el-form-item>
            <el-form-item prop="quarter_month_discount">
              <el-input-number
                v-model="info.quarter_month_discount"
                :min="0"
                :max="1000"
                :precision="2"
                :controls="false"
                placeholder="请输入数字"
                style="margin-left:-170px;width:146px"
              ></el-input-number>
              <span style="margin-left:5px">元</span>
            </el-form-item>
          </div>

          <div class="flex">
            <el-form-item label="年卡会员购药立减" prop="year_month_times">
              <span>每月</span>
              <el-input-number
                v-model="info.year_month_times"
                :min="0"
                :max="99"
                :precision="0"
                :controls="false"
                placeholder="请输入数字"
                style="margin:0 5px;width:146px"
              ></el-input-number>
              <span>次</span>
            </el-form-item>
            <el-form-item prop="year_month_discount">
              <el-input-number
                v-model="info.year_month_discount"
                :min="0"
                :max="1000"
                :precision="2"
                :controls="false"
                placeholder="请输入数字"
                style="margin-left:-170px;width:146px"
              ></el-input-number>
              <span style="margin-left:5px">元</span>
            </el-form-item>
          </div>
          <div class="flex">
            <el-form-item label="年卡内部会员购药立减" prop="staff_year_month_times">
              <span>每月</span>
              <el-input-number
                v-model="info.staff_year_month_times"
                :min="0"
                :max="99"
                :precision="0"
                :controls="false"
                placeholder="请输入数字"
                style="margin:0 5px;width:146px"
              ></el-input-number>
              <span>次</span>
            </el-form-item>
            <el-form-item prop="staff_year_month_discount">
              <el-input-number
                v-model="info.staff_year_month_discount"
                 :min="0"
                :max="1000"
                :precision="2"
                :controls="false"
                placeholder="请输入数字"
                style="margin-left:-170px;width:146px"
              ></el-input-number>
              <span style="margin-left:5px">元</span>
            </el-form-item>
          </div>
          <div class="flex">
            <el-form-item label="新用户购药立减" prop="new_user_times">
              <span style="margin-left:14px">共</span>
              <el-input-number
                v-model="info.new_user_times"
                :min="0"
                :max="99"
                :precision="0"
                :controls="false"
                placeholder="请输入数字"
                style="margin:0 5px;width:146px"
              ></el-input-number>
              <span>次</span>
            </el-form-item>
            <el-form-item prop="new_user_discount">
              <el-input-number
                v-model="info.new_user_discount"
                :min="0"
                :max="1000"
                :precision="2"
                :controls="false"
                placeholder="请输入数字"
                style="margin-left:-170px;width:146px"
              ></el-input-number>
              <span style="margin-left:5px">元</span>
            </el-form-item>
          </div>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
import dayjs from "dayjs";

export default {
  data() {
    return {
      info: {
        exchange_limit: undefined,
        quarter_money: undefined,
        quarter_renew_money: undefined,
        year_money: undefined,
        year_renew_money: undefined,
        quarter_month_times: undefined,
        quarter_month_discount: undefined,
        year_month_times: undefined,
        year_month_discount: undefined,
        staff_year_month_times: undefined,
        staff_year_month_discount: undefined,
        new_user_times: undefined,
        new_user_discount: undefined,
        exchange_type: 0
      },
      rules: {
        exchange_limit: [
          { required: true, message: "请输入数字", trigger: "blur" }
        ],
        quarter_money: [
          { required: true, message: "请输入数字", trigger: "blur" }
        ],
        quarter_renew_money: [
          { required: true, message: "请输入数字", trigger: "blur" }
        ],
        year_money: [
          { required: true, message: "请输入数字", trigger: "blur" }
        ],
        year_renew_money: [
          { required: true, message: "请输入数字", trigger: "blur" }
        ],
        quarter_month_times: [
          { required: true, message: "请输入数字", trigger: "blur" }
        ],
        quarter_month_discount: [
          { required: true, message: "请输入数字", trigger: "blur" }
        ],
        year_month_times: [
          { required: true, message: "请输入数字", trigger: "blur" }
        ],
        year_month_discount: [
          { required: true, message: "请输入数字", trigger: "blur" }
        ],
        staff_year_month_times: [
          { required: true, message: "请输入数字", trigger: "blur" }
        ],
        staff_year_month_discount: [
          { required: true, message: "请输入数字", trigger: "blur" }
        ],
        new_user_times: [
          { required: true, message: "请输入数字", trigger: "blur" }
        ],
        new_user_discount: [
          { required: true, message: "请输入数字", trigger: "blur" }
        ]
      }
    };
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    }
  },
  created() {
    //获取信息
    this.getInfo();
  },
  methods: {
    //获取信息
    getInfo() {
      this.axios.post("platform/shop/getShopExchangeSetting").then(res => {
        this.info = res.data.info;
      });
    },
    //提交
    submit() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          let data = this.info;
          this.axios
            .post("platform/shop/saveShopExchangeSetting", data)
            .then(res => {
              this.$message.success("提交成功");
              this.getInfo();
            });
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.container {
  padding: 20px;
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
  text-align: left;
}
.title {
  font-weight: 700;
  font-size: 18px;
  margin-bottom: 16px;
}
</style>


